import { ITextValue } from '@/types/common';

export enum CustomLayerTypesEnum {
  packages_parcel= 'packages/parcel',
  industrial = 'industrial',
  office = 'office',
  retail = 'retail',
  multi_family = 'multi-family',
  farm_and_ranch = 'farm and ranch',
  residential = 'residential',
  transportation = 'transportation',
  labor = 'labor',
}

export const customLayerTypesLabels = {
  [CustomLayerTypesEnum.packages_parcel]: 'Packages/Parcel',
  [CustomLayerTypesEnum.industrial]: 'Industrial',
  [CustomLayerTypesEnum.office]: 'Office',
  [CustomLayerTypesEnum.retail]: 'Retail',
  [CustomLayerTypesEnum.multi_family]: 'Multi-Family',
  [CustomLayerTypesEnum.farm_and_ranch]: 'Land',
  [CustomLayerTypesEnum.residential]: 'Residential',
  [CustomLayerTypesEnum.transportation]: 'Transportation',
  [CustomLayerTypesEnum.labor]: 'Labor',
}

export const getCustomLayerFormTypes = (types: CustomLayerTypesEnum[]): ITextValue<CustomLayerTypesEnum>[] => {
  return types.map((key) => {
    return {
      text: customLayerTypesLabels[key],
      value: key,
    }
  });
}
